import { Inject, Injectable } from "@angular/core";
import { IErrorData } from "../interfaces/error/error-data.interface";
import { BasicError } from "./basic-error";
import { EToastItemType } from "../enum/toast/toast-entry-type.enum";
import { EErrorType } from "../enum/error/error-type.enum";

@Injectable()
export class AuthenticationError extends BasicError {

  constructor(
    @Inject(BasicError) messageOrData?: string | IErrorData | unknown,
    @Inject(BasicError) code?: string,
    @Inject(BasicError) toastType?: EToastItemType | undefined,
  ) {
    super(messageOrData, code, toastType);
    this.type = EErrorType.Authentication;
  }

}
